import axios from "../../../../../../api/axiosInstance";
import { BulkCreateVouchersRequest, BulkCreateVouchersResponse } from "./types";

export const bulkCreateVouchers = async (
  requestData: BulkCreateVouchersRequest,
): Promise<BulkCreateVouchersResponse> => {
  const response = await axios.post<BulkCreateVouchersResponse>(
    "/api/private/event-vouchers/bulk-create",
    requestData,
  );
  return response.data;
};
